import defaultToEmptyObject from "ramda-extension/es/defaultToEmptyObject";
import { useCallback } from 'react';
import { first } from 'rxjs/operators';
import useContextOrStorage from '../../stream/useContextOrStorage';
/**
 * Hooks will provide function which will load formData on demand.
 *
 * @documented
 * @category State
 * @import import useFormData from '@gef-ui/form-core/hooks/state/useFormDataLazy'
 * @param {String} [formName] - when used, formStream$ is taken from stream storage instead of context
 * @returns {Function} getFormData - function which will return promise
 * @example
 *
 * 	const getFormData = useFormDataLazy();
 *  const formData = await getFormData();
 *
 */ const useFormDataLazy = (formName)=>{
    const { formData$ } = defaultToEmptyObject(useContextOrStorage(formName));
    const getFormData = useCallback(()=>formData$.pipe(first()).toPromise(), [
        formData$
    ]);
    return formData$ ? getFormData : undefined;
};
export default useFormDataLazy;
